import React, { useState, useEffect } from 'react';
import { 
  Button, 
  Input, 
  Modal, 
  Form, 
  Spin, 
  Table,
  Space,
  Tag,
  message,
  Popconfirm,
  Empty,
  Typography,
  ConfigProvider,
  Pagination,
  Select,
  Badge,
  Card,
  Row,
  Col
} from 'antd';
import { 
  FaEdit, 
  FaSearch, 
  FaUtensils,
  FaClipboardList,
  FaTimesCircle,
  FaChair
} from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../api/Api';
import formatarValor from '../formatarValor';

const { Title } = Typography;

const GerenciarPedidos = () => {
  // Estados principais
  const [pedidos, setPedidos] = useState([]);
  const [mesas, setMesas] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingPedidosMesa, setLoadingPedidosMesa] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  
  // Estados para modais e seleção
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isProdutosModalVisible, setIsProdutosModalVisible] = useState(false);
  const [selectedPedido, setSelectedPedido] = useState(null);
  const [selectedMesa, setSelectedMesa] = useState(null);
  const [pedidosMesa, setPedidosMesa] = useState([]);
  const [cancelForm] = Form.useForm();
  const [cancelAllForm] = Form.useForm();
  const [showModalImpressao, setShowModalImpressao] = useState(false);
const [numeroDocumento, setNumeroDocumento] = useState(null);


  // Cores do degradê
  const primaryColor = 'rgb(249, 130, 68)';
  const secondaryColor = 'rgb(247, 72, 115)';
  const gradient = `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`;

  useEffect(() => {
    fetchMesas();
    fetchProdutos();
  }, []);

      useEffect(() => {
     document.title = "Pedidos";
   
  }, []);

  const fetchMesas = async () => {
    try {
      setLoading(true);
      const mesasData = await Api.ListMesaPedido();
     
      const mesasFormatadas = Array.isArray(mesasData) 
        ? mesasData.map(mesa => ({
            ...mesa,
            status: mesa.status_mesa
          }))
        : [];
      setMesas(mesasFormatadas);
    } catch (error) {
      console.error('Erro ao carregar mesas:', error);
      toast.error('Erro ao carregar mesas: ' + error.message);
      setMesas([]);
    } finally {
      setLoading(false);
    }
  };

const handleEnviarParaCozinha = async () => {
  if (!selectedMesa) {
    message.warning("Selecione uma mesa primeiro");
    return;
  }

  try {
    setLoading(true);
    const dados = { id: selectedMesa.id };
    const response = await Api.EnviarCozinha(dados);

    if (response && response.success) {
      toast.success("Pedidos enviados para a cozinha!");
      await fetchPedidosMesa(selectedMesa.id);  // atualiza lista
      await fetchMesas();
    } else {
      toast.error(response?.message || "Erro ao enviar pedidos para cozinha");
    }
  } catch (error) {
    console.error("Erro ao enviar para cozinha:", error);
    toast.error("Erro ao enviar para cozinha: " + error.message);
  } finally {
    setLoading(false);
  }
};


const handleEntregarProduto = async (pedidoId) => {
  try {
    setLoading(true);
    const dados = { id: pedidoId };
    const response = await Api.EntregarProduto(dados);

    if (response && response.success) {
      toast.success("Produto entregue com sucesso!");
      if (selectedMesa) {
        await fetchPedidosMesa(selectedMesa.id);
        await fetchMesas();
      }
    } else {
      toast.error(response?.message || "Erro ao entregar bebida");
    }
  } catch (error) {
    console.error("Erro ao entregar bebida:", error);
    toast.error("Erro ao entregar bebida: " + error.message);
  } finally {
    setLoading(false);
  }
};


  const fetchProdutos = async () => {
    try {
      const produtosData = await Api.ListProduto();
      setProdutos(Array.isArray(produtosData) ? produtosData : []);
    } catch (error) {
      console.error('Erro ao carregar produtos:', error);
      toast.error('Erro ao carregar produtos: ' + error.message);
      setProdutos([]);
    }
  };

  const fetchPedidosMesa = async (mesaId) => {
    try {
      setLoadingPedidosMesa(true);
      const dados = { id: mesaId };
      const pedidosData = await Api.ListPedidoMesa(dados);
      console.log(`Pedidos da mesa ${mesaId}:`, pedidosData);
      
      const pedidosFormatados = Array.isArray(pedidosData) ? pedidosData : [];
      setPedidosMesa(pedidosFormatados.map(p => ({ 
        ...p,
        key: p.id,
        observacao: p.obs,
        preco: p.preco
      })));
    } catch (error) {
      console.error('Erro ao carregar pedidos da mesa:', error);
      toast.error('Erro ao carregar pedidos da mesa: ' + error.message);
      setPedidosMesa([]);
    } finally {
      setLoadingPedidosMesa(false);
    }
  };

  const handleMesaClick = async (mesa) => {
    console.log('Mesa clicada:', mesa);
    if (mesa.status !== 'OCUPADA') {
      message.info('Mesa está disponível - não há pedidos');
      return;
    }
    
    setSelectedMesa(mesa);
    await fetchPedidosMesa(mesa.id);
  };

  // Cancelar pedido individual
  const handleCancelarPedido = async (pedidoId, motivo) => {
    try {
      setLoading(true);
      const dados = { id: pedidoId, obs:motivo };
      const response = await Api.CancelarPedidoOnly(dados);
      
      if(response && response.success){
        toast.success('Pedido cancelado com sucesso!');
        if (selectedMesa) {
          await fetchPedidosMesa(selectedMesa.id);
          await fetchMesas();
        }
      } else {
        toast.error(response?.message || 'Erro ao cancelar pedido');
      }
    } catch (error) {
      console.error('Erro ao cancelar pedido:', error);
      toast.error('Erro ao cancelar pedido: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Cancelar todos os pedidos da mesa
  const handleCancelarTodosPedidos = async (motivo) => {
    if (!selectedMesa) {
      message.warning('Selecione uma mesa primeiro');
      return;
    }

    try {
      setLoading(true);
      const dados = { id: selectedMesa.id, obs:motivo };
      const response = await Api.CancelarPedido(dados);
      
      if(response && response.success){
        toast.success('Todos os pedidos da mesa foram cancelados com sucesso!');
        await fetchPedidosMesa(selectedMesa.id);
        await fetchMesas();
        
        // Volta para a lista de mesas após cancelar todos
        setSelectedMesa(null);
        setPedidosMesa([]);
      } else {
        toast.error(response?.message || 'Erro ao cancelar pedidos da mesa');
      }
    } catch (error) {
      console.error('Erro ao cancelar pedidos da mesa:', error);
      toast.error('Erro ao cancelar pedidos da mesa: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

const handleFecharTodosPedidos = async () => {
  if (!selectedMesa) {
    message.warning('Selecione uma mesa primeiro');
    return;
  }

  try {
    setLoading(true);
    const dados = { id: selectedMesa.id };
    const response = await Api.AddDocumento(dados);

    if (response.success) {

      // 🔹 Guardar número do documento para usar no modal
      setNumeroDocumento(response.numero);
      setShowModalImpressao(true);

      toast.success('Todos os pedidos da mesa foram fechados com sucesso!');
      await fetchPedidosMesa(selectedMesa.id);
      await fetchMesas();

      setSelectedMesa(null);
      setPedidosMesa([]);

    } else {
      toast.error(response?.message || 'Erro ao fechar pedidos da mesa');
    }

  } catch (error) {
    console.error('Erro ao fechar pedidos da mesa:', error);
    toast.error('Erro ao fechar pedidos da mesa: ' + error.message);
  } finally {
    setLoading(false);
  }
};



  const renderStatusTag = (status) => {
    let color = '';
    let text = '';
    
    switch(status) {
      case 'ABERTO':
        color = 'blue';
        text = 'ABERTO';
        break;
      case 'PENDENTE':
        color = 'orange';
        text = 'PENDENTE';
        break;
      case 'FECHADO':
        color = 'green';
        text = 'FECHADO';
        break;
      case 'CANCELADO':
        color = 'red';
        text = 'CANCELADO';
        break;
      case 'OCUPADA':
        color = 'blue';
        text = 'OCUPADA';
        break;
      case 'DISPONIVEL':
        color = 'green';
        text = 'DISPONÍVEL';
        break;
      default:
        color = 'gray';
        text = status;
    }
    
    return (
      <Tag color={color}>
        {text}
      </Tag>
    );
  };

  const getProdutoNome = (id_produto) => {
    const produto = produtos.find(p => p.id === id_produto);
    return produto ? produto.descricao : 'Produto não encontrado';
  };

  const getProdutoDetalhes = (id_produto) => {
    const produto = produtos.find(p => p.id === id_produto);
    return produto || null;
  };

  const mostrarDetalhesProduto = (pedido) => {
    const produto = getProdutoDetalhes(pedido.id_produto);
    if (produto) {
      setSelectedPedido({ ...pedido, produtoDetalhes: produto });
      setIsProdutosModalVisible(true);
    }
  };

  // Função para verificar se há pedidos pendentes na mesa
  const hasPedidosPendentes = () => {
    return pedidosMesa.some(pedido => 
      pedido.status === 'ABERTO' || pedido.status === 'PENDENTE'
    );
  };

  // Função para calcular o total da mesa
  const calcularTotalMesa = () => {
    return pedidosMesa.reduce((total, pedido) => {
      if (pedido.status !== 'CANCELADO') {
        return total + ((pedido.preco || 0) * (pedido.quantidade || 0));
      }
      return total;
    }, 0);
  };

  const mesasArray = Array.isArray(mesas) ? mesas : [];
  
  const filteredMesas = mesasArray.filter(mesa => {
    if (!mesa) return false;
    return (
      mesa.descricao?.toString().toLowerCase().includes(searchText.toLowerCase()) ||
      mesa.status?.toString().toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const paginatedMesas = filteredMesas.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const columnsPedidos = [
    {
      title: 'Produto',
      dataIndex: 'id_produto',
      key: 'produto',
      render: (id_produto, record) => (
        <Button 
          type="link" 
          onClick={() => mostrarDetalhesProduto(record)}
          style={{ padding: 0, height: 'auto' }}
        >
          {getProdutoNome(id_produto)}
        </Button>
      )
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantidade',
      key: 'quantidade',
      align: 'center'
    },
    {
      title: 'Preço Unitário',
      key: 'preco',
      render: (_, record) => formatarValor(record.preco || 0),
      align: 'right'
    },
    {
      title: 'Total',
      key: 'total',
      render: (_, record) => {
        const total = (record.preco || 0) * (record.quantidade || 0);
        return <strong>{formatarValor(total)}</strong>;
      },
      align: 'right'
    },
    {
      title: 'Observação',
      dataIndex: 'observacao',
      key: 'observacao',
      ellipsis: true,
      render: (text) => text || '-'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: renderStatusTag
    },
    {
  title: 'Ações',
  key: 'acoes',
  render: (_, record) => (
    <Space size="small">

      {/* BOTÃO ENTREGAR */}
{(
    // 1) BEBIDA = S → entregar quando status = ABERTO
    (record.bebida === 'S' && record.status === 'ABERTO')  
) && (
    <Button
      size="small"
      type="primary"
      style={{ background: '#52c41a', border: 'none' }}
      onClick={() => handleEntregarProduto(record.id)}
    >
      Entregar
    </Button>
)}


      {/* CANCELAR Pedido */}
      {record.status === 'ABERTO' && (
        <Popconfirm
          title="Cancelar Pedido"
          description={
            <div>
              <p>Informe o motivo do cancelamento:</p>
              <Form
                form={cancelForm}
                onFinish={(values) => {
                  handleCancelarPedido(record.id, values.motivo);
                  return Promise.resolve();
                }}
              >
                <Form.Item
                  name="motivo"
                  rules={[{ required: true, message: 'Informe o motivo do cancelamento' }]}
                >
                  <Input.TextArea 
                    placeholder="Motivo do cancelamento" 
                    rows={3}
                    maxLength={255}
                  />
                </Form.Item>
              </Form>
            </div>
          }
          onConfirm={async () => {
            try {
              await cancelForm.validateFields();
              cancelForm.submit();
            } catch (error) {
              console.log('Validação falhou:', error);
            }
          }}
          okText="Confirmar"
          cancelText="Cancelar"
          onCancel={() => cancelForm.resetFields()}
        >
          <Button 
            size="small" 
            danger
          >
            Cancelar
          </Button>
        </Popconfirm>
      )}

      {(record.status === 'FECHADO' || record.status === 'CANCELADO') && (
        <span style={{ color: '#999', fontSize: '12px' }}>
          Nenhuma ação disponível
        </span>
      )}

    </Space>
  ),
},

  ];

  const renderProdutosModal = () => (
    <Modal
      title="Detalhes do Produto"
      open={isProdutosModalVisible}
      onCancel={() => setIsProdutosModalVisible(false)}
      footer={[
        <Button 
          key="close" 
          onClick={() => setIsProdutosModalVisible(false)}
        >
          Fechar
        </Button>
      ]}
      width={500}
    >
      {selectedPedido?.produtoDetalhes ? (
        <div>
          <h4>{selectedPedido.produtoDetalhes.descricao}</h4>
          <p><strong>Preço:</strong> {formatarValor(selectedPedido.produtoDetalhes.preco || 0)}</p>
          {selectedPedido.produtoDetalhes.observacao && (
            <p><strong>Descrição:</strong> {selectedPedido.produtoDetalhes.observacao}</p>
          )}
          <p><strong>Quantidade no Pedido:</strong> {selectedPedido.quantidade || 0}</p>
          <p><strong>Total:</strong> {formatarValor((selectedPedido.preco || 0) * (selectedPedido.quantidade || 0))}</p>
          {selectedPedido.observacao && (
            <p><strong>Observação do Pedido:</strong> {selectedPedido.observacao}</p>
          )}
        </div>
      ) : (
        <p>Detalhes do produto não disponíveis</p>
      )}
    </Modal>
  );

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: primaryColor,
          borderRadius: 8,
        },
      }}
    >
      <div style={{ 
        padding: 24,
        background: '#f8f9fa',
        minHeight: '100vh'
      }}>
        <ToastContainer position="top-right" />
        
        {/* Cabeçalho */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          marginBottom: 24,
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 16
        }}>
          <Title level={2} style={{ 
            margin: 0,
            background: gradient,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            {selectedMesa ? `PEDIDOS - MESA ${selectedMesa.descricao}` : 'MESAS'}
          </Title>
          
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center' }}>
            <Input
              placeholder="Pesquisar mesas..."
              prefix={<FaSearch style={{ color: 'rgba(0,0,0,0.3)' }} />}
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setCurrentPage(1);
              }}
              style={{ 
                width: 250,
                borderRadius: 8,
                border: '1px solid rgba(0,0,0,0.1)'
              }}
            />
            
            {selectedMesa && (
              <Button 
                onClick={() => {
                  setSelectedMesa(null);
                  setPedidosMesa([]);
                  cancelForm.resetFields();
                  cancelAllForm.resetFields();
                }}
                style={{ borderRadius: 6 }}
              >
                Voltar para Mesas
              </Button>
            )}
          </div>
        </div>

        {!selectedMesa ? (
          // Lista de Mesas
          <Spin spinning={loading}>
            {filteredMesas.length > 0 ? (
              <>
                <div style={{ marginBottom: 16 }}>
                  <p>Total de mesas: {filteredMesas.length}</p>
                </div>
                <Row gutter={[16, 16]}>
                  {paginatedMesas.map(mesa => (
                    <Col xs={24} sm={12} md={8} lg={6} key={mesa.id}>
                      <Card
                        hoverable
                        onClick={() => handleMesaClick(mesa)}
                        style={{
                          borderRadius: 8,
                          border: `2px solid ${
                            mesa.status === 'OCUPADA' ? '#1890ff' : 
                            mesa.status === 'DISPONIVEL' ? '#52c41a' : '#d9d9d9'
                          }`,
                          cursor: mesa.status === 'OCUPADA' ? 'pointer' : 'not-allowed',
                          opacity: mesa.status === 'OCUPADA' ? 1 : 0.6
                        }}
                        styles={{ body: { padding: 16 } }}
                      >
                        <div style={{ textAlign: 'center' }}>
                          <FaChair 
                            size={32} 
                            color={
                              mesa.status === 'OCUPADA' ? primaryColor : 
                              mesa.status === 'DISPONIVEL' ? '#52c41a' : '#d9d9d9'
                            } 
                          />
                          <Title level={4} style={{ margin: '8px 0' }}>
                            Mesa {mesa.descricao}
                          </Title>
                          <Tag 
                            color={
                              mesa.status === 'OCUPADA' ? 'blue' : 
                              mesa.status === 'DISPONIVEL' ? 'green' : 'default'
                            }
                          >
                            {mesa.status === 'OCUPADA' ? 'OCUPADA' : 
                             mesa.status === 'DISPONIVEL' ? 'DISPONÍVEL' : mesa.status}
                          </Tag>
                          {mesa.status !== 'OCUPADA' && (
                            <div style={{ marginTop: 8, color: '#999', fontSize: 12 }}>
                              Sem pedidos
                            </div>
                          )}
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
                
                {/* Paginação */}
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  marginTop: 32,
                  padding: '16px 0'
                }}>
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={filteredMesas.length}
                    onChange={(page) => setCurrentPage(page)}
                    showSizeChanger={false}
                  />
                </div>
              </>
            ) : (
              <Empty
                description="Nenhuma mesa encontrada"
                style={{ 
                  marginTop: 50,
                  padding: 40,
                  background: '#fff',
                  borderRadius: 12
                }}
              />
            )}
          </Spin>
        ) : (
          // Lista de Pedidos da Mesa Selecionada
          <Spin spinning={loadingPedidosMesa}>
            <div style={{ marginBottom: 16, padding: 16, background: '#fff', borderRadius: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
                <div>
                  <h3>Pedidos da Mesa {selectedMesa.descricao}</h3>
                  <p>Status da Mesa: {renderStatusTag(selectedMesa.status)}</p>
                  <p>Total de pedidos: {pedidosMesa.length}</p>
                  <p><strong>Valor Total: {formatarValor(calcularTotalMesa())}</strong></p>
                </div>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>

  {pedidosMesa.some(p => p.status === 'ABERTO') && (
    <Button
      type="primary"
      size="large"
      icon={<FaUtensils />}
      style={{
        background: primaryColor,
        border: 'none',
        borderRadius: 6
      }}
      onClick={handleEnviarParaCozinha}
    >
      Enviar para Cozinha
    </Button>
  )}

                  {hasPedidosPendentes() && (
                    <>
                      <Popconfirm
                        title="Fechar Todos os Pedidos"
                        description="Tem certeza que deseja fechar todos os pedidos desta mesa?"
                        onConfirm={handleFecharTodosPedidos}
                        okText="Sim"
                        cancelText="Não"
                      >
                        <Button 
                          type="primary"
                          size="large"
                          style={{ 
                            background: '#52c41a',
                            border: 'none',
                            borderRadius: 6
                          }}
                        >
                          Fechar Pedidos
                        </Button>
                      </Popconfirm>
                      
                      <Popconfirm
                        title="Cancelar Todos os Pedidos"
                        description={
                          <div>
                            <p>Informe o motivo do cancelamento:</p>
                            <Form
                              form={cancelAllForm}
                              onFinish={(values) => {
                                handleCancelarTodosPedidos(values.motivo);
                                return Promise.resolve();
                              }}
                            >
                              <Form.Item
                                name="motivo"
                                rules={[{ required: true, message: 'Informe o motivo do cancelamento' }]}
                              >
                                <Input.TextArea 
                                  placeholder="Motivo do cancelamento" 
                                  rows={3}
                                  maxLength={255}
                                />
                              </Form.Item>
                            </Form>
                          </div>
                        }
                        onConfirm={async () => {
                          try {
                            await cancelAllForm.validateFields();
                            cancelAllForm.submit();
                          } catch (error) {
                            console.log('Validação falhou:', error);
                          }
                        }}
                        okText="Confirmar"
                        cancelText="Cancelar"
                        onCancel={() => cancelAllForm.resetFields()}
                      >
                        <Button 
                          danger
                          size="large"
                          style={{ borderRadius: 6 }}
                        >
                          Cancelar Todos
                        </Button>
                      </Popconfirm>
                    </>
                  )}
                </div>
              </div>
            </div>
            
            {pedidosMesa.length > 0 ? (
              <Table
                columns={columnsPedidos}
                dataSource={pedidosMesa}
                pagination={false}
                style={{
                  borderRadius: 8,
                  overflow: 'hidden'
                }}
                scroll={{ x: true }}
              />
            ) : (
              <Empty
                description="Nenhum pedido encontrado para esta mesa"
                style={{ 
                  marginTop: 50,
                  padding: 40,
                  background: '#fff',
                  borderRadius: 12
                }}
              />
            )}
          </Spin>
        )}

        {renderProdutosModal()}
        <div style={{ display: 'none' }}>
          <Form form={cancelForm} />
          <Form form={cancelAllForm} />
        </div>
      </div>
      <Modal
  title="Imprimir Documento"
  open={showModalImpressao}
  onCancel={() => setShowModalImpressao(false)}
  footer={[
    <Button key="nao" onClick={() => setShowModalImpressao(false)}>
      Não
    </Button>,
    <Button
      key="sim"
      type="primary"
      onClick={() => {
        window.open(`https://socialite.milvendas.ao/factura_ticket/${numeroDocumento}`, '_blank');
        setShowModalImpressao(false);
      }}
    >
      Sim
    </Button>,
  ]}
>
  <p>Deseja imprimir o documento agora?</p>
</Modal>

    </ConfigProvider>
  );
};

export default GerenciarPedidos;